import { default as Controller } from "controllers/tooltip_controller"
import { MediaQuery } from 'foundation-sites';
import tippy from 'tippy.js'
import { debounce } from "common/utils";

export default class extends Controller {
  tip = null

  connect() {
    super.connect()
    document.body.addEventListener('toggle-dashboard', () => this.toggle())
    window.addEventListener('resize', debounce(() => this.toggle(), 250))
  }

  create() {
    if(this.hasTextValue && this.textValue.trim().length > 0) {
      this.tip ??= tippy(this.element, {content: this.textValue, allowHTML: true, placement: 'right' });    
      this.toggle()
    }
  }

  toggle() {
    let visible = this.sidebarVisible

    if(this.enabled !== !visible) {
      if(visible) {
        this.tip?.disable()
        this.enabled = false
      } else {
        this.tip?.enable()
        this.enabled = true
      }
    }
  }

  get sidebarVisible() {
    if(MediaQuery.is('large') || MediaQuery.is('xxlarge')) {
      if(document.querySelector('.app-dashboard:not(.shrink-large)')) return true;
    } else if(MediaQuery.is('medium')) {
      if(document.querySelector('.app-dashboard:not(.shrink-medium)')) return true;
    }
    return false;
  }

  get hasTextValue() {
    return this.element.hasAttribute("data-tooltip-text-value");
  }

  get textValue() {
    return this.element.getAttribute("data-tooltip-text-value");
  }
}
